import React from 'react';
import Select from 'react-select';
import { extraNameAndCode } from '../../../../../utils/contracting-preset-names-codes';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import RateTable from '../../../generic-components/rate-tables/rate-table-template-container';
import TaxCurrencyCommissionForm from '../../../generic-components/rate-forms/tax-currency-commission-form';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const ratesTableNotValid = R.compose(
  R.isEmpty,
  R.reject(R.propOr('', 'notApplicable')),
  R.propOr([], 'rates')
);

export const extraMissingInfo = extra => !extra.extraType || !(extra.taxInclusion === 'exempt' || extra.taxType) || !extra.taxInclusion || !extra.currency
  || ratesTableNotValid(extra);
const EditExtra = ({
  offersOrExtras,
  onTextFieldChangeWithKeyPath,
  updateFormData,
}) => {
  if (!offersOrExtras.selectedId || isNilOrEmpty(offersOrExtras.list)) return <div/>;
  const selectedIndex = offersOrExtras.list.findIndex(o => o._id === offersOrExtras.selectedId);
  const currentExtra = offersOrExtras.list[selectedIndex];
  const { extraType, extraCode, description, taxType, taxInclusion, currency, rateType, commissionPercentage, nettCommission } = currentExtra;
  const extraNameSelectFields = Object.keys(extraNameAndCode).map(nameAndCode => ({ label: nameAndCode, value: nameAndCode }));
  // NonAccomRateTable for soft release
  const updateTableCell = ({ value, row, column }) => {
    onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'rates', row, column], value });
  };
  return (
    <div style={{ padding: '16px 0' }}>
      <div style={{ display: 'flex', marginBottom: '8px' }}>
        <div style={{ width: '130px' }}> Extra type <small style={{ color: 'red', display: !extraType ? 'block' : 'none' }}> * Required</small></div>
        <div style={{ width: '70%' }}>
          <Select
            name="extraType"
            options={extraNameSelectFields}
            value={extraType}
            onChange={({ value }) => onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'extraType'], value })}
            placeholder="Please select extra type"
            clearable={false}
            scrollMenuIntoView={false}
          />
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '8px' }}>
        <div style={{ width: '130px' }}>Extra code</div>
        <TypeControlledTextField
          id="extraCode"
          style={{ width: '70%' }}
          hintText={extraNameAndCode[extraType]}
          value={extraCode || ''}
          onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'extraCode'], value })}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '8px' }}>
        <div style={{ width: '130px' }}>Description</div>
        <div style={{ width: '70%' }}>
          <textarea
            id="description"
            rows={8}
            defaultValue={description}
            onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'description'], value })}
          />
        </div>
      </div>
      <TaxCurrencyCommissionForm
        taxInclusion={taxInclusion}
        taxType={taxType}
        currency={currency}
        rateType={rateType}
        commissionPercentage={commissionPercentage}
        nettCommission={nettCommission}
        updateFunc={
          (field, value) => {
            if (['taxInclusion', 'taxType', 'currency'].indexOf(field) > -1) {
              updateFormData({ keyPath: ['offersOrExtras', 'list', selectedIndex, field], fieldName: field, value: value.trim() }, 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', 'location');
            } else {
              onTextFieldChangeWithKeyPath({
                keyPath: ['offersOrExtras', 'list', selectedIndex, field],
                value,
              });
            }
          }
        }
      />
      <RateTable productType="Non-Accommodation" withEditableCell rateSet={{ ...currentExtra }} updateTableCell={updateTableCell} />
      {
        ratesTableNotValid(currentExtra) && <div style={{ color: 'red' }}>At least one rate detail is required.</div>
      }
    </div>
  );
};

export default EditExtra;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/extras/edit-extra.jsx